export default __webpack_public_path__ + "images/index_block4_1.jpg";